export default __webpack_public_path__ + "static/media/dashboard-passengers.d11b4cd6.svg";